var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "header",
      staticClass: "header",
      class: { "header--chat": _vm.chatWindowStatus == 3 },
    },
    [
      _vm.chatWindowStatus == 1 || _vm.chatWindowStatus == 4
        ? _c("Greeting", {
            attrs: {
              isUserLogged: _vm.isUserLogged,
              name: _vm.name,
              message: _vm.chatWindowStatusMessage,
              showExit: _vm.chatWindowStatus == 4,
            },
            on: { closeChat: _vm.closeChat },
          })
        : _vm.chatWindowStatus == 5 ||
          _vm.chatWindowStatus == 2 ||
          _vm.chatWindowStatus == 6
        ? _c("HeaderTop", {
            attrs: {
              isUserLogged: _vm.isUserLogged,
              currentType: _vm.currentType,
              chatWindowStatusMessage: _vm.chatWindowStatusMessage,
            },
            on: { closeChat: _vm.closeChat },
          })
        : _vm.chatWindowStatus == 3
        ? _c("AgentGreeting", {
            attrs: { agent: _vm.agent, currentType: _vm.currentType },
            on: { closeChat: _vm.closeChat },
          })
        : _vm._e(),
      _c("button", {
        staticClass: "action-icon minimize",
        attrs: { "aria-label": _vm.$gettext("Minimizar chat"), tabindex: "0" },
        on: {
          click: _vm.closeChatWindow,
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.closeChatWindow.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }